/**
 * 操作符
 */
export var operates = [
    { name: "大于", value: ">", enable: ["RANGE"] },
    { name: "大于等于", value: ">=", enable: ["RANGE"] },
    { name: "等于", value: "==", enable: ["EQUALS", "RANGE"] },
    { name: "小于等于", value: "<=", enable: ["RANGE"] },
    { name: "小于", value: "<", enable: ["RANGE"] },
    { name: "包含", value: "in", enable: ["CONTAIN_EQUALS"] },
    { name: "不包含", value: "notin", enable: ["CONTAIN_EQUALS"] }
];
/**
 * 表达式连接符
 */
export var links = {
    relation: {
        first: [
            { name: "空置", value: " " }
        ],
        normal: [
            { name: "并且", value: "&&" },
            { name: "或者", value: "||" }
        ],
    },
    bracket: {
        left: [
            { name: "(", value: "(" },
            { name: "((", value: "((" }
        ],
        right: [
            { name: ")", value: ")" },
            { name: "))", value: "))" }
        ]
    }
};
